import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useCallback, useEffect, useState } from "react";
import ComplaintBookViewModel from "./ComplaintBookViewModel";
import debounce from "lodash.debounce";



interface ColumnMeta {
  field: string;
  header: string;
  editable: boolean;
}

export const  ComplaintBookView = () => {
    const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});
    
    const {
    getComplaintBooks,
    complaintBooks,
    } = ComplaintBookViewModel();

    type LazyParamsType = {
        first: number;
        rows: number;
    };
      
      
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [lazyParams, setLazyParams] = useState<LazyParamsType>({
        first: 1,
        rows: 10,
    });
    
    const columns: ColumnMeta[] = [
        {field: 'name', header: 'Nombre', editable: false},
        {field: 'paternalLastName', header: 'Apellido paterno', editable: false},
        {field: 'maternalLastName', header: 'Apellido materno', editable: false},
        {field: 'documentType', header: 'Tipo de documento', editable: false},
        {field: 'documentNumber', header: 'DNI', editable: false},
        {field: 'email', header: 'Correo', editable: false },
        {field: 'department', header: 'Departamento', editable: false },
        {field: 'claimType', header: 'Tipo de reclamo', editable: false },
        {field: 'created', header: 'Fecha de creación', editable: false },
        {field: 'options', header: 'Opciones', editable: false },
    ];
      
    useEffect(() => {
        const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
        loadComplaintBooks(lazyParams.first ?? 1, lazyParams.rows ?? 10, search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lazyParams, filters]);
    
    
    const loadComplaintBooks = async (first: number, rows: number, search: string = '') => {
        setLoading(true);
        const page = Math.floor(first / rows);
        //const search = filters?.global?.value || '';

        console.log(page);

        try {
            const result = await getComplaintBooks(page+1, rows, search);
            
            setTotalRecords(result.totalCount);
        } catch (error) {
            console.error("Error al cargar clientes", error);
        } finally {
            setLoading(false);
        }
    };

    // const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const value = event.target.value;
    //     let _filters = { ...filters };
    //     // @ts-ignore
    //     _filters['global'].value = value.toString() || '';

    //     setFilters(_filters);
    //     // setGlobalFilterValue(value);
    // };

    //  Guardamos el texto en un estado normal
    const [inputValue, setInputValue] = useState("");
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = useCallback(
      debounce((sortOrder: string) => {
        loadComplaintBooks(lazyParams.first ?? 1, lazyParams.rows ?? 10, sortOrder);
      }, 500),
      [lazyParams]
    );
    
    // Limpieza del debounce al desmontar
    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);


    const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        
        setInputValue(value.trim());
        // solo dispara la búsqueda cuando hay un valor completo
        if (value.trim().length > 0) {
        
            debouncedSearch(value.trim());
        } else {
            // Si está vacío, recargar todo sin filtro
            loadComplaintBooks(lazyParams.first, lazyParams.rows, "");
        } 
    };
    
    const header = ()=>{
        // @ts-ignore
        //const value = filters['global'] ? filters['global'].value : '';

        return (
            <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                <h4 className="m-0">
                </h4>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" value={inputValue} onChange={(e) => 
                        onGlobalFilterChange(e)} placeholder="Buscar..." />
                </span>
            </div>
        )
    };
    
        //   const documentType = (status: number) => {
    
        //     return(
        //         <>
        //             <div className="d-flex">
        //               <div className={`p-2 text-white rounded-2 ${status === 0 ? 'bg-danger' : 'bg-success' }`}>{status === 0 ? <FontAwesomeIcon className="fs-2" icon={icon({name: 'user-large-slash'})} /> : <FontAwesomeIcon className="fs-2" icon={icon({name: 'user-large'})} />}</div>
        //             </div>
        //         </>
        //     );
        // }

        const btnOptions = (id: string)=>{
            return( 
                <div className="d-inline">
                    <a href={`/detalle-libro-reclamaciones/${id}`} className="btn btn-dark">
                        <FontAwesomeIcon icon={icon({name: 'eye'})} />
                    </a>&nbsp;
                </div>
            );
        };
        
        return (
            <>
              <div className="container-fluid">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                            <h2>Listado de libros de reclamaciones</h2>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                                </li>
                                <li className="breadcrumb-item">Libro de reclamaciones</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-flex flex-row-reverse">
                                <div className="page_action">
                                    {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                                </div>
                                <div className="p-2 d-flex">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='title-report'>
                        Aquí puedes ver los registros de reclamaciones de los usuarios
                    </div>
                    {/* <InputSwitch  key={'index01254'} checked={checkedw} onChange={(e: InputSwitchChangeEvent) =>  setCheckedw(!checkedw)} /> */}
                    
                </div>
                <div className='row'>
                  <div className='col-lg-12'>
                    <DataTable 
                        value={complaintBooks!} lazy paginator 
                        rows={lazyParams.rows} 
                        first={lazyParams.first} 
                        totalRecords={totalRecords} 
                        loading={loading} 
                        editMode="cell" 
                        rowsPerPageOptions={[5, 10, 15, 20]} 
                        tableStyle={{    minWidth: '50rem' }}
                        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                        globalFilterFields={['firstName', 'lastName', 'dni', 'email', 'phoneNumber']} 
                        emptyMessage="No customers found." 
                        stateStorage="session"
                        header={header} 
                        filters={filters} 
                        onFilter={(e) => setFilters(e.filters)}
                    >
                        {columns.map(({ field, header, editable  }) => {
                                return <Column key={field} field={field} header={header}
                                body={
                                  field === 'options' ? (e)=> btnOptions(e.id) : null
                                }
                                // editor={editable ? (options) => cellEditor(options) : undefined}
                                // onCellEditComplete={onCellEditComplete}
                                />
                        })}
                    </DataTable>
                   </div>
                </div>
              </div>
            </>
        );
}